// extracted by mini-css-extract-plugin
export var active = "healthCareWhatWeDo-module--active--8b096";
export var arrow = "healthCareWhatWeDo-module--arrow--5ff07";
export var card_desc = "healthCareWhatWeDo-module--card_desc--fe036";
export var card_desc_coll = "healthCareWhatWeDo-module--card_desc_coll--62c1a";
export var card_title = "healthCareWhatWeDo-module--card_title--d73d5";
export var card_title_hover = "healthCareWhatWeDo-module--card_title_hover--81d20";
export var heading = "healthCareWhatWeDo-module--heading--00cfa";
export var healthcare_left = "healthCareWhatWeDo-module--healthcare_left--24d07";
export var healthcare_right = "healthCareWhatWeDo-module--healthcare_right--d4c73";
export var healthcare_wrap = "healthCareWhatWeDo-module--healthcare_wrap--d0e0b";
export var section_class = "healthCareWhatWeDo-module--section_class--d5e5d";
export var serve_wrap = "healthCareWhatWeDo-module--serve_wrap--57848";